import React from "react";
import NavBar from "../components/NavBar";

const EMICalculator = () => {
    return(
        <div>
            <NavBar/>
            EMI Calculator
        </div>
    )
}

export default EMICalculator;